import Api from "./Api";
import store from "../state/store";

export default {
  // pushRestart(macAddress) {
  //   return Api({ daemonRequest: true }).post(`/kiosks/push-restart/${macAddress}`);
  // },
  // restartApp(macAddress) {
  //   return Api({ daemonRequest: true }).post(`/kiosks/restart-app/${macAddress}`);
  // },
  // updateApp(macAddress, version) {
  //   return Api({ daemonRequest: true }).post(`/kiosks/update-app/${macAddress}`, { key: version });
  // },
  // remoteShowScreen(macAddress) {
  //   return Api({ daemonRequest: true }).post(`/kiosks/remote-show-screen/${macAddress}`);
  // },
  // kioskLogging(macAddress) {
  //   return Api({ daemonRequest: true }).post(`/kiosks/kiosk-logging/${macAddress}`);
  // },
  // forceResyncWithLogs(macAddress) {
  //   return Api({ daemonRequest: true }).post(`/kiosks/force-resync-with-logs/${macAddress}`);
  // },
  // pullDatabase(macAddress) {
  //   return Api({ daemonRequest: true }).post(`/kiosks/pull-database/${macAddress}`);
  // },
  // openDoor(macAddress) {
  //   return Api({ daemonRequest: true }).post(`/kiosks/open-door/${macAddress}`);
  // },
  openDoor(kioskInfo) {
    const requestObject = this.getUserAndKioskInfo(kioskInfo);
    return Api({ daemonRequest: true }).post('/kiosks/open-door', requestObject);
  },
  pushRestart(kioskInfo) {
    const requestObject = this.getUserAndKioskInfo(kioskInfo);
    return Api({ daemonRequest: true }).post('/kiosks/push-restart', requestObject);
  },
  restartApp(kioskInfo) {
    const requestObject = this.getUserAndKioskInfo(kioskInfo);
    return Api({ daemonRequest: true }).post('/kiosks/restart-app', requestObject);
  },
  remoteShowScreen(kioskInfo) {
    const requestObject = this.getUserAndKioskInfo(kioskInfo);
    return Api({ daemonRequest: true }).post('/kiosks/remote-show-screen', requestObject);
  },
  pullDatabase(kioskInfo) {
    const requestObject = this.getUserAndKioskInfo(kioskInfo);
    return Api({ daemonRequest: true }).post('/kiosks/pull-database', requestObject);
  },
  refreshFaceLibrary(kioskInfo) {
    const requestObject = this.getUserAndKioskInfo(kioskInfo);
    return Api({ daemonRequest: true }).post('/kiosks/refresh-face-library', requestObject);
  },
  kioskLogging(kioskInfo) {
    const requestObject = this.getUserAndKioskInfo(kioskInfo);
    return Api({ daemonRequest: true }).post('/kiosks/kiosk-logging', requestObject);
  },
  updateApp(mac_address, version, kiosk_name) {
    const requestObject = this.getUserAndKioskInfo({
      kiosk_name,
      mac_address
    });
    Object.assign(requestObject, { key: version })
    return Api({ daemonRequest: true }).post(`/kiosks/update-app`, requestObject);
  },
  // forceResyncWithLogs(macAddress) {
  //   return Api({ daemonRequest: true }).post(`/kiosks/force-resync-with-logs/${macAddress}`);
  // },
  fetchAppVersions() {
    return Api({ daemonRequest: true }).get(`/kiosks/app-versions`);
  },
  //reporting -> kiosk logs
  fetchRequestLogs() {
    const entityId = store.getters["authfack/currentEntity"].id
    const userId = store.getters["authfack/userDetails"].id
    return Api({ daemonRequest: true }).get(`/kiosks/requests/entity/${entityId}/${userId}`);
  },
  fetchKioskRequestLogs(macAddress) {
    // console.log('preview logs')
    return Api({ daemonRequest: true }).get(`/kiosks/requests/${macAddress}/${store.getters["authfack/userDetails"].id}`);
  },
  getKioskInfo(macAddress) {
    return Api({ daemonRequest: true }).get(`/kiosks/${macAddress}`);
  },
  remoteControlNotifyToStart(kioskInfo) {
    const requestObject = this.getUserAndKioskInfo(kioskInfo);
    return Api({ daemonRequest: true }).post(`/kiosks/notify-remote-screen-share-start`, requestObject);
  },
  remoteControlNotifyToEnd(kioskInfo) {
    const requestObject = this.getUserAndKioskInfo(kioskInfo);
    return Api({ daemonRequest: true }).post(`/kiosks/notify-remote-screen-share-end`, requestObject);
  },
  getRoomInfo(macAddress) {
    return Api({ daemonRequest: true }).get(`kiosks/room-data/${macAddress}`)
  },
  getUserAndKioskInfo(kioskInfo) {
    const entity_id = store.getters["authfack/currentEntity"].id
    const user = store.getters["authfack/userDetails"]
    const user_name = user.fullName
    const is_super_admin = user.email == "lt_techteam@visipoint.com" ? 1 : 0;
    return {
      kioskName: kioskInfo.kiosk_name,
      macAddress: kioskInfo.mac_address,
      entityId: entity_id,
      userName: user_name,
      isSuperAdmin: is_super_admin,
    }
  },
};
